import React from 'react';
import findResult from '@/utils/resultsHelper';
import { readStates, states } from '@/constants/lifecycle';
import PanelContainer from '@/components/wrappers/PanelContainer';
import {
  updateSearchProperties,
  fetchSearch,
  fetchSearchConfig,
  performFind,
} from '../actions';

const SearchPanelContainer = ({
  canRun,
  children,
  description,
  exists,
  isDirty,
  isNew,
  name,
  onChange,
  readErrors,
  readStatus,
  url,
}) => (
  <PanelContainer
    canAccess={canRun}
    description={description}
    entity="search"
    exists={exists}
    isDirty={!isNew && isDirty}
    isNew={isNew}
    name={name}
    onChange={onChange}
    readErrors={readErrors}
    readStatus={[readStatus]}
    url={url}
  >
    {children}
  </PanelContainer>
);

const accessControl = (role, exists) => (
  {
    exists,
    canRun: exists ? role.permissions.search.run : false,
  }
);

const withSearchConfigProps = (searchConfig) => (
  {
    searchConfigStatus: searchConfig ? searchConfig.readStatus : states.NONE,
    searchConfig: searchConfig ? searchConfig.config : {},
  }
);

const withoutItem = (role, searchConfig) => (
  {
    ...accessControl(role, false),
    ...readStates,
    ...withSearchConfigProps(searchConfig),
    filtersVisible: false,
  }
);

const withItem = (item, role, searchConfig) => (
  {
    ...accessControl(role, true),
    search: item,
    isNew: item.isNew,
    isDirty: item.isDirty,
    readStatus: item.readStatus,
    readErrors: item.readErrors,
    name: item.name,
    description: item.description,
    ...withSearchConfigProps(searchConfig),
    filtersVisible: item.filtersVisible,
  }
);

export const mapStateToProps = ({
  auth: { role },
  search: { searches, searchConfig },
}, { category, code }) => {
  const item = findResult(searches, category, code);
  return item ? withItem(item, role, searchConfig) : withoutItem(role, searchConfig);
};

export const mapDispatchToProps = {
  fetchData: fetchSearch,
  fetchSearchConfig,
  setFiltersVisible: updateSearchProperties,
  fetchSearch: performFind,
};

export default SearchPanelContainer;
